export default "__VITE_ASSET__DpUaXgdn__"